export default {"src":"/_next/static/media/play-button.a936e120.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};